// composables/useNotificationSocket.js
import { onBeforeUnmount } from 'vue';
import { io } from 'socket.io-client';
import { useToastStore } from '@/components/helper/toast';
import { useNotificationStore } from '@/stores/useNotificationStore';

export function useNotificationSocket() {
  const toastStore = useToastStore();
  const notificationStore = useNotificationStore();
  let socket = null;

  const initSocket = (userId) => {
    const apiUrl = import.meta.env.VITE_API_BASE_URL;


    if (!userId || !apiUrl) {
      console.warn('[WS] Missing userId or VITE_API_BASE_URL, skipping connection');
      return;
    }

    // Disconnect socket lama jika sudah ada
    if (socket) {
      socket.disconnect();
      socket = null;
    }

    socket = io(`${apiUrl}/notifications`, {
      query: { userId },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });

    socket.on('connect', () => {

    });

    socket.on('toast-notification', (payload) => {
      toastStore.show({
        message: `${payload.title}: ${payload.description}`,
        type: payload.type,
        position: 'top-right',
      });

      if (payload.id != null) {
        notificationStore.addNotifiedId(payload.id);
      }

    });

    socket.on('connect_error', (err) => {
      console.error('[WS] Connection error:', err.message);
    });

    socket.on('disconnect', (reason) => {
      console.log('[WS] Disconnected:', reason);
    });
  };

  onBeforeUnmount(() => {
    socket?.disconnect();
  });

  return { initSocket };
}
